module.exports = "img/directory-big.cc09e49.png";